import React from "react";

const ColorText = (props) => {
  return <span style={{ color: `${props.color}` }}>{props.children}</span>;
};

export default ColorText;